<div class="hint-dialog">
  <div class="hint">
    <p *ngIf="empty()"><span [ghs-label]="'round.hint.empty'"></span></p>
    <p *ngIf="missingInitiative()"><span [ghs-label]="'round.hint.missingInitiative'"></span> </p>
    <p *ngIf="active()"><span [ghs-label]="'round.hint.active'"></span></p>
    <a *ngIf="active()" (click)="confirm()"><span [ghs-label]="'round.hint.confirm'"></span></a>
    <a *ngIf="active()" (click)="next()" class="small"><span [ghs-label]="'round.hint.confirmTurns'"></span></a>
    <p *ngIf="finish()"><span [ghs-label]="'round.hint.finish'"></span></p>
    <a *ngIf="finish()" (click)="finishScenario(true)"><span [ghs-label]="'round.hint.confirmFinish'"></span></a>
    <p *ngIf="failed()"><span [ghs-label]="'round.hint.failed'"></span></p>
    <a *ngIf="failed()" (click)="finishScenario(false)"><span [ghs-label]="'round.hint.confirmFailed'"></span></a>
    <a *ngIf="failed()" (click)="resetScenario()"><span [ghs-label]="'round.hint.confirmReset'"></span></a>
    <a *ngIf="finish() || failed()" (click)="confirm()"><span [ghs-label]="(gameManager.game.state == GameState.next ?
      'round.hint.continueNext' : 'round.hint.continueDraw')"></span></a>
    <p *ngIf="battleGoals()"><span [ghs-label]="'round.hint.battleGoals'"></span></p>
    <a *ngIf="battleGoals()" (click)="confirm()"><span [ghs-label]="'round.hint.confirm'"></span></a>
    <p *ngIf="eventDraw() && gameManager.game.eventDraw"><span [ghs-label]="'round.hint.eventDraw'"
        [ghs-label-args]="[gameManager.game.eventDraw]"></span></p>
    <a *ngIf="eventDraw()" (click)="confirm()"><span [ghs-label]="'round.hint.confirm'"></span></a>
  </div>
</div>